import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { SelectModule } from 'primeng/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ReportEstudantesComponent } from '../components/report-estudantes/report-estudantes.component';
import { ReportProfissionaisComponent } from '../components/report-profissionais/report-profissionais.component';
import { ReportVagasComponent } from '../components/report-vagas/report-vagas.component';
import { ReportDocumentosComponent } from '../components/report-documentos/report-documentos.component';

@Component({
  selector: 'app-home-report',
  imports: [
    CommonModule,
    SelectModule,
    ReportEstudantesComponent,
    ReportProfissionaisComponent,
    ReportVagasComponent,
    ReportDocumentosComponent,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './home-report.component.html',
  styleUrls: ['./home-report.component.scss'],
})
export class HomeReportComponent implements OnInit {
  selectedOption: any = 'documentos';
  options = [
    { label: 'Relatório de Documentos e Candidaturas', value: 'documentos' },
    { label: 'Relatório de Profissionais', value: 'profissionais' },
    { label: 'Relatório de Estudantes', value: 'estudantes' },
    { label: 'Relatório de Vagas', value: 'vagas' },
  ];

  get currentOption(): string {
    if (!this.selectedOption) return '';
    if (typeof this.selectedOption === 'string') return this.selectedOption;
    return this.selectedOption?.value || '';
  }

  ngOnInit(): void {}
}
